import { DEFAULT_DOMAIN_CONFIG, DOMAIN_MODULE_CONFIG } from "@/constants/domain-module-config"
import {
  AimOutlined,
  CalendarOutlined,
  ContainerFilled,
  ControlOutlined,
  FileImageOutlined,
  FileOutlined,
  FlagOutlined,
  GlobalOutlined,
  HomeOutlined,
  PictureOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  ShopOutlined,
  SnippetsOutlined,
  TagOutlined,
  TeamOutlined,
  TruckOutlined,
  UserDeleteOutlined,
  VideoCameraOutlined
} from "@ant-design/icons"
import { ItemType, MenuItemType } from "antd/es/menu/interface"
import {
  BANNERS,
  CAMPAIGNS,
  CAMPAIGN_SUBSCRIBERS,
  CAREERS,
  CAREER_FORM,
  CATEGORIES,
  CONTACTFORM,
  CONTACT_FORMS,
  CUSTOMERS,
  EVENTS,
  EVENT_SUBSCRIBERS,
  LETAKY,
  MEDIA,
  PAGES,
  POSTS,
  ROLES,
  SETTINGS,
  SETTINGS_TAMDAMEDIA,
  SETTINGS_TAMDAONE,
  STORES,
  SUPPLIERS,
  TOURS,
  TRANSLATIONS,
  USERS,
  VIDEO,
  WEBSITES,
  YOUTUBE_VIDEO,
} from "../../constants/admin-paths"

export type MenuItem = ItemType & {
  path?: string
  permission?: string
  parent?: string
  children?: MenuItem[]
  label?: string
}

export interface CustomMenuItem extends MenuItemType {
  label: string
  key: string
  icon?: React.ReactNode
  children?: CustomMenuItem[]
  path?: string
  permission?: string
  /**
   * Ngoài quyền `find`, menu chỉ hiện khi role có ÍT NHẤT 1 action trong danh sách.
   * Dùng khi cần cấp quyền đọc cho role khác (vd select user ở form khác) mà
   * không muốn lộ menu quản trị.
   */
  menuRequiresAny?: string[]
  parent?: string
}

export const settingItems: CustomMenuItem[] = [
  {
    key: SETTINGS.LIST.PATH,
    label: SETTINGS.LIST.LABEL,
  },
  {
    key: SETTINGS.CREATE.PATH,
    label: SETTINGS.CREATE.LABEL,
  },
]

export const postItems: CustomMenuItem[] = [
  {
    key: POSTS.LIST.PATH,
    label: POSTS.LIST.LABEL,
  },
  {
    key: POSTS.CREATE.PATH,
    label: POSTS.CREATE.LABEL,
  },
]

export const mediaItems: CustomMenuItem[] = [
  {
    key: MEDIA.LIST.PATH,
    label: MEDIA.LIST.LABEL,
  },
]

export const contactForm: CustomMenuItem[] = [
  {
    key: CONTACTFORM.LIST.PATH,
    label: CONTACTFORM.LIST.LABEL,
  },
  {
    key: CONTACTFORM.CREATE.PATH,
    label: CONTACTFORM.CREATE.LABEL,
  },
]

export const contactFormItems: CustomMenuItem[] = [
  {
    key: CONTACT_FORMS.LIST.PATH,
    label: CONTACT_FORMS.LIST.LABEL,
  },
  {
    key: CONTACT_FORMS.CREATE.PATH,
    label: CONTACT_FORMS.CREATE.LABEL,
  },
]

export const usersItems: CustomMenuItem[] = [
  {
    key: USERS.LIST.PATH,
    label: USERS.LIST.LABEL,
  },
  {
    key: USERS.CREATE.PATH,
    label: USERS.CREATE.LABEL,
  },
  {
    key: USERS.PROFILE.PATH,
    label: USERS.PROFILE.LABEL,
  },
]

export const rolesItems: CustomMenuItem[] = [
  {
    key: ROLES.LIST.PATH,
    label: ROLES.LIST.LABEL,
  },
  {
    key: ROLES.CREATE.PATH,
    label: ROLES.CREATE.LABEL,
  },
]

export const pageItems: CustomMenuItem[] = [
  {
    key: PAGES.LIST.PATH,
    label: PAGES.LIST.LABEL,
  },
  {
    key: PAGES.CREATE.PATH,
    label: PAGES.CREATE.LABEL,
  },
]

export const categoriesItems: CustomMenuItem[] = [
  {
    key: CATEGORIES.LIST.PATH,
    label: CATEGORIES.LIST.LABEL,
  },
  // {
  //   key: CATEGORIES.EDIT.PATH,
  //   label: CATEGORIES.EDIT.LABEL,
  // },
  {
    key: CATEGORIES.CREATE.PATH,
    label: CATEGORIES.CREATE.LABEL,
  },
]

export const tourItems: CustomMenuItem[] = [
  {
    key: TOURS.LIST.PATH,
    label: TOURS.LIST.LABEL,
  },
  {
    key: TOURS.CREATE.PATH,
    label: TOURS.CREATE.LABEL,
  },
]

export const customerItems: CustomMenuItem[] = [
  {
    key: CUSTOMERS.LIST.PATH,
    label: CUSTOMERS.LIST.LABEL,
  },
  {
    key: CUSTOMERS.CREATE.PATH,
    label: CUSTOMERS.CREATE.LABEL,
  },
]

export const careerFormItems: CustomMenuItem[] = [
  {
    key: CAREER_FORM.LIST.PATH,
    label: CAREER_FORM.LIST.LABEL,
  },
  {
    key: CAREER_FORM.CREATE.PATH,
    label: CAREER_FORM.CREATE.LABEL,
  },
]

export const campaignSubscriberItems: CustomMenuItem[] = [
  {
    key: CAMPAIGN_SUBSCRIBERS.LIST.PATH,
    label: CAMPAIGN_SUBSCRIBERS.LIST.LABEL,
  },
  {
    key: CAMPAIGN_SUBSCRIBERS.CREATE.PATH,
    label: CAMPAIGN_SUBSCRIBERS.CREATE.LABEL,
  },
]

export const campaignItems: CustomMenuItem[] = [
  {
    key: CAMPAIGNS.LIST.PATH,
    label: CAMPAIGNS.LIST.LABEL,
  },
  {
    key: CAMPAIGNS.CREATE.PATH,
    label: CAMPAIGNS.CREATE.LABEL,
  },
]

export const eventSubscriberItems: CustomMenuItem[] = [
  {
    key: EVENT_SUBSCRIBERS.LIST.PATH,
    label: EVENT_SUBSCRIBERS.LIST.LABEL,
  },
  {
    key: EVENT_SUBSCRIBERS.CREATE.PATH,
    label: EVENT_SUBSCRIBERS.CREATE.LABEL,
  },
]

export const eventItems: CustomMenuItem[] = [
  {
    key: EVENTS.LIST.PATH,
    label: EVENTS.LIST.LABEL,
  },
  {
    key: EVENTS.CREATE.PATH,
    label: EVENTS.CREATE.LABEL,
  },
]

export const letakyItems: CustomMenuItem[] = [
  {
    key: LETAKY.LIST.PATH,
    label: LETAKY.LIST.LABEL,
  },
  {
    key: LETAKY.CREATE.PATH,
    label: LETAKY.CREATE.LABEL,
  },
]
export const bannerItems: CustomMenuItem[] = [
  {
    key: BANNERS.LIST.PATH,
    label: BANNERS.LIST.LABEL,
  },
  {
    key: BANNERS.CREATE.PATH,
    label: BANNERS.CREATE.LABEL,
  },
]

export const videoItems: CustomMenuItem[] = [
  {
    key: VIDEO.LIST.PATH,
    label: VIDEO.LIST.LABEL,
  },
  {
    key: VIDEO.CREATE.PATH,
    label: VIDEO.CREATE.LABEL,
  },
]

export const youtubeVideoItems: CustomMenuItem[] = [
  {
    key: YOUTUBE_VIDEO.LIST.PATH,
    label: YOUTUBE_VIDEO.LIST.LABEL,
  },
  {
    key: YOUTUBE_VIDEO.CREATE.PATH,
    label: YOUTUBE_VIDEO.CREATE.LABEL,
  },
]

export const careerItems: CustomMenuItem[] = [
  {
    key: CAREERS.LIST.PATH,
    label: CAREERS.LIST.LABEL,
  },
  {
    key: CAREERS.CREATE.PATH,
    label: CAREERS.CREATE.LABEL,
  },
]

export const websiteItems: CustomMenuItem[] = [
  {
    key: WEBSITES.LIST.PATH,
    label: WEBSITES.LIST.LABEL,
  },
  {
    key: WEBSITES.CREATE.PATH,
    label: WEBSITES.CREATE.LABEL,
  },
]

export const settingsTamdaMediaItems: CustomMenuItem[] = [
  {
    key: SETTINGS_TAMDAMEDIA.LIST.PATH,
    label: SETTINGS_TAMDAMEDIA.LIST.LABEL,
  },
]

export const settingsTamdaOneItems: CustomMenuItem[] = [
  {
    key: SETTINGS_TAMDAONE.LIST.PATH,
    label: SETTINGS_TAMDAONE.LIST.LABEL,
  },
]

export const storeItems: CustomMenuItem[] = [
  {
    key: STORES.LIST.PATH,
    label: STORES.LIST.LABEL,
  },
  {
    key: STORES.CREATE.PATH,
    label: STORES.CREATE.LABEL,
  },
]

export const supplierItems: CustomMenuItem[] = [
  {
    key: SUPPLIERS.LIST.PATH,
    label: SUPPLIERS.LIST.LABEL,
  },
  {
    key: SUPPLIERS.CREATE.PATH,
    label: SUPPLIERS.CREATE.LABEL,
  },
]

/**
 * Legacy flat menu (28 top-level items). Kept around because some callers
 * may still reference it. New shell uses `menuItems` below which groups
 * modules into 7 stack groups per Lane C plan.
 */
export const legacyFlatMenuItems: Array<CustomMenuItem> = [
  { label: "Dashboard", key: "", icon: <HomeOutlined /> },
  { label: "Post", key: "post", icon: <FileOutlined />, children: postItems, permission: "post" },
  { label: "Page", key: "pages", icon: <SnippetsOutlined />, children: pageItems, permission: "page" },
  { label: "Categories", key: "categories", icon: <FileOutlined />, children: categoriesItems, permission: "category" },
  { label: "Events", key: "event", icon: <CalendarOutlined />, children: eventItems, permission: "event" },
  { label: "Đối tác sự kiện", key: "subscriber", icon: <TeamOutlined />, children: eventSubscriberItems, permission: "subscriber" },
  { label: "Tin tuyển dụng", key: "career", icon: <FileOutlined />, children: careerItems, permission: "career" },
  { label: "Letaky", key: "letaky", icon: <ContainerFilled />, children: letakyItems, permission: "letak" },
  { label: "Tours", key: "tour", icon: <FlagOutlined />, children: tourItems, permission: "tour" },
  { label: "Customers", key: "customer", icon: <TeamOutlined />, children: customerItems, permission: "member" },
  { label: "Campaign Subscribers", key: "campaign-subscribers", icon: <TeamOutlined />, children: campaignSubscriberItems, permission: "campaign-subscriber" },
  { label: "Campaigns", key: "campaigns", icon: <CalendarOutlined />, children: campaignItems, permission: "campaign" },
  { label: "Contact Forms", key: "contact-forms", icon: <FileOutlined />, children: contactFormItems, permission: "contact-form" },
  { label: "Banners", key: "banners", icon: <PictureOutlined />, children: bannerItems, permission: "banner" },
  { label: "Recruitment Candidates", key: "recruitment-candidates", icon: <TeamOutlined />, children: careerFormItems, permission: "career-form" },
  { label: "Video", key: "video", icon: <VideoCameraOutlined />, children: videoItems, permission: "video" },
  { label: "YouTube Videos", key: "youtube-videos", icon: <PlayCircleOutlined />, children: youtubeVideoItems, permission: "video" },
  { label: "Tags", key: "tags", icon: <TagOutlined />, permission: "tag" },
  { label: "Cửa hàng", key: "store", icon: <ShopOutlined />, children: storeItems, permission: "store" },
  { label: "Nhà cung cấp TDF", key: "supplier", icon: <TruckOutlined />, children: supplierItems, permission: "supllier" },
  { label: "Media", key: "upload", icon: <FileImageOutlined />, children: mediaItems, permission: "content-api" },
  { label: "Menus", key: "menus", icon: <ControlOutlined />, permission: "menu" },
  { label: "Content Templates", key: "block-content", icon: <AimOutlined />, permission: "block-content" },
  { label: "Users", key: "users", children: usersItems, icon: <UserDeleteOutlined />, permission: "user" },
  { label: "Roles", key: "roles", icon: <UserDeleteOutlined />, children: rolesItems, permission: "role" },
  { label: "Settings", key: "settings", icon: <SettingOutlined />, children: settingItems, permission: "setting" },
  { label: "Tamda Media Settings", key: "tamda-media-settings", icon: <SettingOutlined />, permission: "tamda-media-eu-setting" },
  { label: "Tamda One Settings", key: "tamda-one-settings", icon: <SettingOutlined />, permission: "tamda-group-eu-setting" },
  { label: "Websites", key: "websites", icon: <GlobalOutlined />, children: websiteItems, permission: "website" },
]

/**
 * New grouped menu (Lane C). 28 flat items → 7 stack groups.
 * Each leaf points at the module's LIST page; "+ New" lives on the list
 * page header instead of occupying a menu slot.
 *
 * VN-first copy per design review. English tooltip can be added later
 * via a per-item `tooltip` field if needed (tracked in TODOS.md).
 *
 * Keys are route segments under `/admin/` (sider-cms.tsx uses pathname
 * matching to compute active state).
 */
export const menuItems: Array<CustomMenuItem> = [
  { label: "Tổng quan", key: "", icon: <HomeOutlined /> },
  {
    label: "Nội dung",
    key: "group-content",
    icon: <SnippetsOutlined />,
    children: [
      { label: "Trang", key: PAGES.LIST.PATH, icon: <SnippetsOutlined />, permission: "page" },
      { label: "Bài viết", key: POSTS.LIST.PATH, icon: <FileOutlined />, permission: "post" },
      { label: "Danh mục", key: CATEGORIES.LIST.PATH, icon: <FileOutlined />, permission: "category" },
      { label: "Tags", key: "tags", icon: <TagOutlined />, permission: "tag" },
      { label: "Bản dịch", key: TRANSLATIONS.LIST.PATH, icon: <GlobalOutlined />, permission: "translation" },
      { label: "Thư viện media", key: MEDIA.LIST.PATH, icon: <FileImageOutlined />, permission: "content-api" },
    ],
  },
  {
    label: "Marketing",
    key: "group-marketing",
    icon: <PictureOutlined />,
    children: [
      { label: "Banners", key: BANNERS.LIST.PATH, icon: <PictureOutlined />, permission: "banner" },
      { label: "Chiến dịch", key: CAMPAIGNS.LIST.PATH, icon: <CalendarOutlined />, permission: "campaign" },
      { label: "Đăng ký chiến dịch", key: CAMPAIGN_SUBSCRIBERS.LIST.PATH, icon: <TeamOutlined />, permission: "campaign-subscriber" },
      { label: "Menu điều hướng", key: "menus", icon: <ControlOutlined />, permission: "menu" },
    ],
  },
  {
    label: "Kinh doanh",
    key: "group-business",
    icon: <ShopOutlined />,
    children: [
      { label: "Sự kiện", key: EVENTS.LIST.PATH, icon: <CalendarOutlined />, permission: "event" },
      { label: "Đối tác sự kiện", key: EVENT_SUBSCRIBERS.LIST.PATH, icon: <TeamOutlined />, permission: "subscriber" },
      { label: "Tours", key: TOURS.LIST.PATH, icon: <FlagOutlined />, permission: "tour" },
      { label: "Cửa hàng", key: STORES.LIST.PATH, icon: <ShopOutlined />, permission: "store" },
      { label: "Nhà cung cấp", key: SUPPLIERS.LIST.PATH, icon: <TruckOutlined />, permission: "supllier" },
      { label: "Letaky", key: LETAKY.LIST.PATH, icon: <ContainerFilled />, permission: "letak" },
    ],
  },
  {
    label: "Media Hub",
    key: "group-media",
    icon: <VideoCameraOutlined />,
    children: [
      { label: "Video", key: VIDEO.LIST.PATH, icon: <VideoCameraOutlined />, permission: "video" },
      { label: "YouTube", key: YOUTUBE_VIDEO.LIST.PATH, icon: <PlayCircleOutlined />, permission: "video" },
      { label: "Mẫu khối (Puck)", key: "block-content", icon: <AimOutlined />, permission: "block-content" },
    ],
  },
  {
    label: "Nhân sự",
    key: "group-people",
    icon: <TeamOutlined />,
    children: [
      { label: "Khách hàng", key: CUSTOMERS.LIST.PATH, icon: <TeamOutlined />, permission: "member" },
      {
        label: "Người dùng",
        key: USERS.LIST.PATH,
        icon: <UserDeleteOutlined />,
        permission: "user",
        // users-permissions dùng "destroy" thay cho "delete".
        menuRequiresAny: ["create", "update", "destroy"],
      },
      { label: "Vai trò", key: ROLES.LIST.PATH, icon: <UserDeleteOutlined />, permission: "role" },
      { label: "Tin tuyển dụng", key: CAREERS.LIST.PATH, icon: <FileOutlined />, permission: "career" },
      { label: "Hồ sơ ứng tuyển", key: CAREER_FORM.LIST.PATH, icon: <TeamOutlined />, permission: "career-form" },
      { label: "Form liên hệ", key: CONTACT_FORMS.LIST.PATH, icon: <FileOutlined />, permission: "contact-form" },
    ],
  },
  {
    label: "Hệ thống",
    key: "group-system",
    icon: <SettingOutlined />,
    children: [
      { label: "Websites", key: WEBSITES.LIST.PATH, icon: <GlobalOutlined />, permission: "website" },
      { label: "Cài đặt chung", key: SETTINGS.LIST.PATH, icon: <SettingOutlined />, permission: "setting" },
      { label: "Cài đặt Tamda Media", key: SETTINGS_TAMDAMEDIA.LIST.PATH, icon: <SettingOutlined />, permission: "tamda-media-eu-setting" },
      { label: "Cài đặt Tamda One", key: SETTINGS_TAMDAONE.LIST.PATH, icon: <SettingOutlined />, permission: "tamda-group-eu-setting" },
    ],
  },
]

// const filterMenuItemsByPermission = (menuItems: MenuItem[], permissions: Record<string, any>): MenuItem[] => {
//   return menuItems.reduce<MenuItem[]>((filteredMenuItems, item) => {
//     const permission = item.permission

//     if (permission) {
//       const hasPermission = permissions[permission]?.find?.enabled === true

//       if (hasPermission) {
//         if (item.children?.length) {
//           const filteredChildren = item.children.filter(child => {
//             const path = child.key?.toString() || ""

//             if (path.includes("/create")) {
//               return permissions[permission]?.create?.enabled === true
//             }
//             return true
//           })

//           if (filteredChildren.length) {
//             filteredMenuItems.push({
//               ...item,
//               children: filteredChildren,
//             })
//           }
//         } else {
//           filteredMenuItems.push(item)
//         }
//       }
//     } else {
//       filteredMenuItems.push(item)
//     }

//     return filteredMenuItems
//   }, [])
// }

// export const getFilteredMenuItems = (): MenuItem[] => {
//   if (typeof window !== "undefined") {
//     const permissions = JSON.parse(localStorage.getItem("permissions") || "{}")
//     const filteredMenuItems = filterMenuItemsByPermission(menuItems, permissions)
//     return filteredMenuItems
//   } else {
//     return menuItems
//   }
// }

function normalizeMenuKey(key: string): string {
  return key.replace(/^\/+/, "")
}

/**
 * Filters menu items based on the domain-module config for the selected site.
 * Must be applied BEFORE permission filtering so empty groups don't linger.
 */
export const filterMenuItemsByDomain = (items: CustomMenuItem[], domain?: string): CustomMenuItem[] => {
  const config = DOMAIN_MODULE_CONFIG[domain ?? ""] ?? DEFAULT_DOMAIN_CONFIG

  return items.reduce<CustomMenuItem[]>((filtered, item) => {
    const groupKey = String(item.key ?? "")
    const rule = config[groupKey]

    // No rule for this group key → pass through unchanged
    if (rule === undefined || rule === "all") {
      filtered.push(item)
      return filtered
    }

    // Empty array → hide the entire group
    if (Array.isArray(rule) && rule.length === 0) {
      return filtered
    }

    // Non-empty whitelist → keep only matching children
    if (Array.isArray(rule)) {
      const allowed = rule.map(normalizeMenuKey)

      if (item.children && item.children.length > 0) {
        const keptChildren = item.children.filter(child =>
          allowed.includes(normalizeMenuKey(String(child.key ?? "")))
        )
        if (keptChildren.length > 0) {
          filtered.push({ ...item, children: keptChildren })
        }
        return filtered
      }

      // Leaf item in whitelist
      if (allowed.includes(normalizeMenuKey(groupKey))) {
        filtered.push(item)
      }
      return filtered
    }

    filtered.push(item)
    return filtered
  }, [])
}

export const filterMenuItemsByPermission = (items: CustomMenuItem[], permissions: any): CustomMenuItem[] => {
  const checkPerm = (perm: string | undefined, action: string = "find"): boolean => {
    if (!perm) return true
    if (!permissions) return false
    const userPerm = permissions[perm]
    if (action === "find") {
      return !!(
        userPerm?.find?.enabled ||
        userPerm?.findMine?.enabled
      )
    }
    return !!userPerm?.[action]?.enabled
  }

  return items.reduce<CustomMenuItem[]>((filtered, item) => {
    // Group items (no own permission, has children):
    // keep only if at least one child survives the filter.
    if (!item.permission && item.children && item.children.length > 0) {
      const survivingChildren = filterMenuItemsByPermission(item.children, permissions)
      if (survivingChildren.length > 0) {
        filtered.push({ ...item, children: survivingChildren })
      }
      return filtered
    }

    // Permission-less leaf (e.g. Dashboard) — always keep.
    if (!item.permission) {
      filtered.push(item)
      return filtered
    }

    // Leaf with permission — keep if user has find access.
    if (!checkPerm(item.permission, "find")) {
      return filtered
    }

    if (item.menuRequiresAny?.length && !item.menuRequiresAny.some(action => checkPerm(item.permission, action))) {
      return filtered
    }

    // Legacy shape: parent item with permission + List/Create children
    // (keep working with `legacyFlatMenuItems` if anyone still uses it).
    if (item.children && item.children.length > 0) {
      const filteredChildren = item.children.filter(child => {
        const path = child.key?.toString() || ""
        if (path.includes("/create")) {
          return checkPerm(item.permission, "create")
        }
        return true
      })
      if (filteredChildren.length > 0) {
        filtered.push({ ...item, children: filteredChildren })
      }
      return filtered
    }

    filtered.push(item)
    return filtered
  }, [])
}
